<template>
  <div class="overflow-x-auto scrollbar-hidden member-datatable" data-test="member-datatable">
      <Datatable :api-params="paramsComputed" :api-url="'user/listUser'" :method-request="'POST'" :data-array-table="dataArrayTable" :key="key" :default-sort="[{field:'uid',dir:'asc'}]" @foundData="handleFoundData"/>
  </div>
</template>

<script>
import Datatable from "@/components/datatable/index.vue"
import { defineComponent,reactive,ref,onMounted, watch, computed } from "vue"
import Swal from "sweetalert2"
import axios from "axios"
import { useStore } from "vuex"

const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary m-1',
    cancelButton: 'btn btn-outline-secondary m-1'
  },
  buttonsStyling: false
})

export default defineComponent({
    props:{
        filter:{
            type: Object
        },
        reloadTable:{
            type: Boolean,
            default: false
        }
    },
    components:{
        Datatable
    },
    setup(props,{emit}){
        const dataArray = ref()
        const params = ref({start: '1',draw: '1',length: '10'})
        const key = ref(1)
        const store = useStore()
        // const foundData = ref(false)
        watch(()=>props.filter, ()=>{
            key.value++
        })
        watch(()=>props.reloadTable,(val)=>{
            if(val){
                key.value++
            }
        })
        const paramsComputed = computed(() => ({...params.value, ...props.filter}))

        const dataArrayTable = reactive([
            {title:"ชื่อผู้ใช้งาน", field:"uid",minWidth: 200, width: 200, resizable:true, formatter:"textarea"},
            {title:"ตำแหน่ง", field:"position",minWidth: 150, width: 150, resizable:true, formatter:"textarea"},
            {title:"หน่วยงาน", field:"organization.agc_name",minWidth: 200, width: 200, resizable:true, formatter:"textarea"},
            {title:"หน่วยงานย่อย", field:"organization.org_name",minWidth: 200, width: 200, resizable:true, formatter:"textarea"},
            {title:"จังหวัด", field:"province_name",minWidth: 150, width: 150, resizable:true, formatter:"textarea"},
            {title:"การดำเนินการ", field:"action", hozAlign:"center", minWidth: 130, width: 130,
                formatter:function(cell, formatterParams){
                    const deleteCallback = () =>{
                        swalCustom.fire({
                            text:"ยืนยันยกเลิกการเชื่อมกับ HCM",
                            icon:"warning",
                            showCancelButton: true,
                            reverseButtons: true,
                            confirmButtonText: 'ตกลง',
                            cancelButtonText: 'ยกเลิก',
                        }).then(async (result) => {
                            if (result.isConfirmed) {
                                const token = store.getters["userAuth/getToken"];
                                const headers = {
                                    Authorization: `Bearer ${token}`,
                                    "Content-Type": `application/json; charset=utf-8`,
                                };
                                const res = await axios.put(`${process.env.VUE_APP_BASE_API}user/${cell.getData()._id} `,
                                    {
                                        update: {
                                            hcm: null
                                        }
                                    },
                                    { headers }
                                )
                                .catch(()=>
                                    swalCustom.fire({
                                        text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                                        icon: "warning",
                                        // timer: 3000, //timeOut for auto-close
                                        confirmButtonText: "ปิด",
                                    })
                                )
                                if (res.status === 200) {
                                    swalCustom.fire({
                                        text:"สำเร็จ",
                                        icon: 'success',
                                        timer: 3000,
                                        confirmButtonText: "ปิด",
                                    }).then(function () {
                                        key.value++
                                    });
                                }
                            }
                        })
                    }
                    if(cell.getData().hcm_linked){
                        let divElm = document.createElement("div")
                        divElm.className = "flex lg:justify-center items-center h-full"
                        let delBtn = document.createElement("a")
                        let delIcon = document.createElement("i");
                        let delText = document.createElement("span")
                        delText.className = "t-tooltip-text"
                        delText.append("ยกเลิกการเชื่อมกับ HCM")
                        delIcon.setAttribute("data-feather","x")
                        delIcon.className = "w-full h-full"
                        delBtn.className = "t-tooltip w-8 h-8 p-[5px] inline-flex justify-center hover:bg-[#22418147]"
                        delBtn.append(delIcon)
                        delBtn.append(delText)
                        delBtn.addEventListener("click", deleteCallback);
                        divElm.append(delBtn)
                        const b = cash(divElm)
                        return b[0]
                    }
                    return null
                }
            },
        ])
        const handleFoundData = (evt) =>{
            // emit("showHcmModal", props.filter.hcm_uid && evt.length > 0 ? evt : null)
            emit("showHcmModal", props.filter.hcm_uid ? evt : null)
        }

        return {
            dataArrayTable,
            params,
            key,
            paramsComputed,
            dataArray,
            handleFoundData
        }
    }
})
</script>

<style lang="scss">

</style>